module.exports = __webpack_public_path__ + "img/f4-1.4d3dfe0a.png";